<script lang="ts" setup>
  import PaymentErrorWidget from '@/widgets/PaymentError/PaymentErrorWidget.vue'
  import { useUserStore } from '@/shared/store'

  const userStore = useUserStore()
</script>

<template>
  <PaymentErrorWidget :variant="userStore.lastFlowDirection" />
</template>
